
import { Component, Vue } from "vue-property-decorator";
import vuexStore from "@/store/vuex-store";
import Auth from "@/lib/common/auth";
import TimeUtil from "@/lib/common/time-util";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import { StructDimensionGroupConfig } from "@/lib/model/exambuilder/configGroup";
import {
  BeforeVideo,
  ExamV2Custom,
  StructExamQuestionCommentConfig,
  StructExamDimensionConfig,
  StructExamQuestionConfig,
  Vir
} from "@/lib/model/exambuilder/exam-v2";
import ExamV3Custom, {
  ExamV3,
  ExamV3Tem
} from "@/lib/model/exambuilder/exam-v3/exam-v3";
import Loading from "@/components/loading.vue";

import BuilderV3Steps from "@/views/ai-builder-v3/components/builder-v3-steps.vue";
import BasicConfiguration from "./step-view/basic-configuration.vue";
import ToolCheck from "./step-view/toolCheck.vue";
import SetQuestions from "./step-view/set-questions.vue";
import SetScore from "./step-view/set-score.vue";
import SetOther from "./step-view/set-other.vue";
import AskGoOn from "@/components/ask-go-on.vue";
import ManageAuth from "@/views/exam-v3/components/manage-auth.vue";
import ModelDrawer from "@/views/ai-builder-v3/components/drawer/index.vue";
import MsgRequest from "@/lib/model/message/MsgRequest";

import { BasicQuality } from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";
import { jobMatchingEnum } from "@/lib/enum/tool";
import { Mind, PsycGaugeConfig } from "@/lib/model/exambuilder/exam-v2";
import { Post } from "@/lib/newExam/post";

@Component({
  components: {
    SetScore,
    SetQuestions,
    ToolCheck,
    BasicConfiguration,
    SetOther,
    AskGoOn,
    ManageAuth,
    ModelDrawer,
    BuilderV3Steps,
    Loading
  }
})
export default class AiBuilder extends Vue {
  //临时用用
  currentTimeAtClickPre = 0;
  markCurrentTime() {
    this.currentTimeAtClickPre = new Date().getTime();
  }
  cacheTemplateList: ExamV3Tem[] = [];
  cachePostList: Post[] = [];
  cacheDimensionList = []; //仅适用第二大步第一小步
  cacheMindList: PsycGaugeConfig[] = [];
  pathText = "新建面试";
  stepShow: boolean[] = [true, false, false, false, false]; //五个步骤显隐
  currentStep = 0; //当前步骤 0 1 2 3 4
  vuexStores = vuexStore;
  examGetForm = new ExamGetForm();
  paperId = 0;
  isEdit = false; //是否编辑页面
  dataInited = false;
  askGoOn = false; //是否继续上次的新建流程
  askTemplateCancel = false; // 是否继续模版选择更改
  isCandidateUsed = false; //是否有候选人答题
  powerExamId = 0; //设置权限的面试id
  showPower = false;
  isFirstEnter = true; // 是否第一次进入toolcheck
  virList: Vir[] = []; //虚拟人列表
  stepsList = [
    {
      title: "考查项选择",
      isComplete: false
    },
    {
      title: "测评工具",
      isComplete: false
    },
    {
      title: "分数配置",
      isComplete: false
    }
  ];
  // 翻页限制速度，防止点击太快
  canChangePage = true;
  canCancelPage = true;
  pageInterval = 300;
  cancelInterval = 500;
  submitting = false;
  userChangeScore = false;

  videoUrlDef =
    "https://vod.hina.com/a3309d04251940faa56806be59bdf122/8c7be05066f64d29ae74ffbd5500daa9-ca173c7e0f3241eb8285dedda051a1ba-ld.mp4"; //视频预览url默认
  descImgUrlDef =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png"; //须知语默认封面

  // 保存定时器，避免频繁写入数据
  saveDataTimer: number | null = null;

  exam: ExamV2Custom = new ExamV2Custom();
  examV3: ExamV3Custom = new ExamV3Custom();
  askSubmit = false; //完成弹窗
  askCancel = false; //完成弹窗
  ask = {
    title: "",
    text: "",
    cancelBtn: "",
    okBtn: ""
  };
  questionOrInspectScoreIsZeroList: any = [];
  showZeroVisible = false;
  companyPower = {}; //公司一些权限
  editExamV3Step234 = false; //单独编辑第234步
  editExamV3Step5 = false; //单独编辑第5步

  basicStatus = false; //创建面试时第一大步加载状态
  toolStatus = false; //面试第二步加载状态
  setQuestionsStatus = false; //面试第三步加载状态
  setScoreStatus = false; //面试第四步加载状态
  setOtherStatus = false; //面试第五步加载状态

  isTemplateNextAfter = false; //是否进入过选择模版之后的设置
  mindList: PsycGaugeConfig[] = [];

  userSureZero = false; // 用户确认分数为0
  // 编辑态时，如果第五步没要求身份证号，切勾选了背景调查，是否同意自动添加身份证
  askAutoAddIdCard = false;
  agreeAutoAddIdCard = false;

  // 按钮状态
  get btnStatus() {
    return (
      (!this.isEdit && this.stepShow[0] && this.basicStatus) ||
      (this.stepShow[1] && this.toolStatus) ||
      (this.stepShow[2] && this.setQuestionsStatus) ||
      (this.stepShow[3] && this.setScoreStatus) ||
      (this.stepShow[4] && this.setOtherStatus)
    );
  }

  get TimeUtil() {
    return TimeUtil;
  }

  async getMindList() {
    const res = await Mind.get();

    if (res.data.code !== 0) return;

    this.mindList = res.data.data.list.map((item: any) => {
      return new PsycGaugeConfig().assign(item);
    });
  }

  // 模版更改信息
  templateInfo = { nextAfter: false, examV3Tem: new ExamV3Tem() };
  cancelTemplateTip() {
    this.askTemplateCancel = false;
    this.isTemplateNextAfter = true;
  }
  templateNextAfter(data: { nextAfter: boolean; examV3Tem: ExamV3Tem }) {
    this.templateInfo = data;
    const { nextAfter } = data;
    if (nextAfter) {
      this.isTemplateNextAfter = false;
      this.ask = {
        title: `提示`,
        text: "修改模板后所有已选考查项及内容会被重置",
        cancelBtn: "取消修改",
        okBtn: "确认修改"
      };
      this.askTemplateCancel = true;
    }
  }
  cancelOkTemplate() {
    const newExam = new ExamV3Custom();
    newExam.basicInformation.name = this.examV3.basicInformation.name;
    newExam.basicInformation.remark = this.examV3.basicInformation.remark;
    newExam.basicInformation.positionId = +this.examV3.basicInformation
      .positionId;
    newExam.basicInformation.positionName = this.examV3.basicInformation.positionName;
    newExam.assign(this.templateInfo.examV3Tem);
    this.selectTemp(newExam);
    this.askTemplateCancel = false;
    const step1 = this.$refs["step1"] as any;
    if (step1 && step1.$refs && step1.$refs["basicModelCard"]) {
      step1.$refs["basicModelCard"].handleClose();
      step1.$refs.basicModelCard.isResumeExam = false;
    }
  }

  async created() {
    this.loadCacheV3();
    this.virList = await Vir.getList();

    this.dataInited = false;
    this.currentStep = 0;

    await this.getMindList();

    if (Number(this.$route?.query?.paperId)) {
      // 编辑进入
      this.paperId = Number(this.$route.query.paperId);
      this.examGetForm.examId = Number(this.paperId);
      this.examGetForm.companyId = Number(Auth.companyId);
      this.currentStep = Number(this.$route?.query?.step ?? 0);
      this.isEdit = true;
      this.pathText = "编辑面试";
      if (this.currentStep === 4) {
        this.editExamV3Step5 = true;
      }
      if (
        this.currentStep === 1 ||
        this.currentStep === 2 ||
        this.currentStep === 3
      ) {
        this.editExamV3Step234 = true;
        this.stepsList.forEach((el, ind) => {
          el.isComplete = true;
        });
      }
      await this.getExam();
    } else {
      // 新建进入 有缓存 询问是否继续新建
      if (localStorage.getItem("aibuildercachev3")) {
        this.askGoOn = true;
      } else {
        // 无缓存 初始化
        this.newCreate();
      }
      this.dataInited = true;
    }

    //进入url指定对应页面 默认0
    this.showCurrentStep(this.currentStep);
    this.vuexStores.updateAiStep({ show: true, step: this.currentStep });
    this.getCompanyPower();
  }
  // afterInitAibuilder: 1;
  // auditDescMust: 1;
  // auditRepeat: 1;
  // auditUndetermined: 1;
  // autoReturnCost: 2;
  // changeUi: 4;
  // description: "";
  // enableAibuilderExam: 1;
  // enableBadHistroy: 1;
  // enableFaceDetection: 1;
  // enableFingerTest: 1;
  // enableGameTest: 1;
  // enableMessageNotice: 1;
  // enableMoneyCheck: 1;
  // enablePeoplePhoneCheck: 1;
  // enablePsycTest: 1;
  // enableReplacePersonCheck: 1;
  // enableWorkerExam: 1;
  // fontColor: "#000000";
  // giveUpNotSignIn: 1;
  // giveUpSignIn: 2;
  // isEnableAi: 1;
  // livenessRecognition: 1;
  // mainColor: "#FFFFFF";
  // openIvh: 1;
  // scoreVersion: 1;
  // showAsr: 1;
  //************************************************************************************************************** */
  // ChangeUi                 EnumUi                 `json:"changeUi"`                 // 候选人答题小程序端UI样式
  //   ShowAsr                  EnumBoolOption         `json:"showAsr"`                  // 是否阅卷展示ASR结果
  //   AuditRepeat              EnumBoolOption         `json:"auditRepeat"`              // 评估页-是否允许重复阅卷
  //   AuditDescMust            EnumBoolOption         `json:"auditDescMust"`            // 评估页-是否评价详情必填
  //   AuditUndetermined        EnumBoolOption         `json:"auditUndetermined"`        // 评估页-是否允许阅卷待定
  //   Description              string                 `json:"description"`              // 旧职位组-公司描述
  //   MainColor                string                 `json:"mainColor"`                // 旧职位组-主题色
  //   FontColor                string                 `json:"fontColor"`                // 旧职位组-背景色
  //   IsEnableAi               EnumBoolOption         `json:"isEnableAi"`               // 是否开启AI
  //   LivenessRecognition      EnumBoolOption         `json:"livenessRecognition"`      // 是否开放人脸核验功能
  //   EnablePsycTest           EnumBoolOption         `json:"enablePsycTest"`           // 是否开放心理测评功能
  //   EnableGameTest           EnumBoolOption         `json:"enableGameTest"`           // 是否开放游戏测评功能
  //   EnableReplacePersonCheck EnumBoolOption         `json:"enableReplacePersonCheck"` // 是否开放换人检测功能
  //   EnableBadHistroy         EnumBoolOption         `json:"enableBadHistroy"`         // 是否开放背调-社会安全功能
  //   EnableMoneyCheck         EnumBoolOption         `json:"enableMoneyCheck"`         // 是否开放背调-金融功能
  //   EnablePeoplePhoneCheck   EnumBoolOption         `json:"enablePeoplePhoneCheck"`   // 是否开放背调-身份识别功能
  //   EnableFingerTest         EnumBoolOption         `json:"enableFingerTest"`         // 是否开放手指检测功能
  //   EnableFaceDetection      EnumBoolOption         `json:"enableFaceDetection"`      // 是否开放露脸检测功能
  //   EnableMessageNotice      EnumBoolOption         `json:"enableMessageNotice"`      // 是否开放面试提醒功能
  //   StyleConfig              map[string]interface{} `json:"styleConfig"`              // 小程序样式配置
  //   AfterInitAibuilder       EnumBoolOption         `json:"afterInitAibuilder"`       // 是否执行过aibuilder初始化
  //   EnableAibuilderExam      EnumBoolOption         `json:"enableAibuilderExam"`      // 是否开放aibuilder通用版
  //   EnableWorkerExam         EnumBoolOption         `json:"enableWorkerExam"`         // 是否开放aibuilder普工版
  //   OpenIvh                  EnumBoolOption         `json:"openIvh"`                  // 是否开放虚拟视频ivh
  //   ScoreVersion             EnumScoreVersion       `json:"scoreVersion"`             // 题目计分下计分类型 0:维度先近似在累加(旧版) 1:维度先累加再近似(新版) 影响算分和评估页
  //   VipLevel                 EnumVipLevel           `json:"vipLevel"`                 // vip类型(close)
  //   TimeLimitGiveUp          int                    `json:"timeLimitGiveUp"`          // 自动过期时间(秒)
  //   GiveUpSignIn             EnumBoolOption         `json:"giveUpSignIn"`             // 已签到是否自动过期
  //   GiveUpNotSignIn          EnumBoolOption         `json:"giveUpNotSignIn"`          // 未签到是否自动过期
  //   AutoReturnCost           EnumBoolOption         `json:"autoReturnCost"`           // 是否自动给已交卷未作答退费
  //   Version                  string                 `json:"version"`                  // 公司版本

  //公司权限
  getCompanyPower() {
    MsgRequest.getCompanyInfo(parseInt(Auth.companyId)).then((res: any) => {
      if (res.code === 0) {
        this.companyPower = res.data.companySpecialConfig;
      }
    });
  }

  sureZero() {
    this.showZeroVisible = false;
    if (this.isEdit) {
      this.userSureZero = true;
      this.submitting = false;
      this.submitV3(1);
      return;
    }
    this._next();
  }

  // 获取面试信息
  async getExam(getInfo = true) {
    const res = await ExamV3.get(this.examGetForm);

    if (getInfo) {
      this.examV3 = new ExamV3Custom().assign(res);
      // this.examV3.setDefaultValue();
      this.pathText = "编辑面试-" + this.examV3.basicInformation.name;
    }

    this.isCandidateUsed = this.examV3.isCandidateUsed === 1;
    this.dataInited = true;
  }

  // 步骤控制
  showCurrentStep(index: number) {
    this.currentStep = index;
    this.vuexStores.updateAiStep({ show: true, step: index });
    // if (index >= 1 && index <= 4) {
    //   this.stepsList.forEach((el, ind) => {
    //     if (index > ind) {
    //       el.isComplete = true;
    //     }
    //   });
    // }
    this.stepShow.forEach((item: boolean, i: number) => {
      this.$set(this.stepShow, i, index === i);
    });

    // 刷新保持当前页面 更新url
    const urlParams = this.$route.query;

    // 没有step
    if (!urlParams?.step) {
      const url = this.$route.fullPath + "&step=" + this.currentStep;
      return window.history.pushState("", "", url);
    }

    // url更新step
    urlParams.step = String(this.currentStep);
    const params = Object.entries(urlParams).reduce(
      (pre, [key, val]) => `${pre}${key}=${val}&`,
      "?"
    );
    const url = this.$route.path + params.substring(0, params.length - 1);
    window.history.pushState("", "", url);
  }

  // 取消
  cancel() {
    if (!this.canChangePage) return;

    this.ask = {
      title: `提示`,
      text: "您做的修改尚未保存，确定退出吗？",
      cancelBtn: "取消",
      okBtn: "退出"
    };

    this.askCancel = true;
  }

  // 是否已有候选人答题
  checkHasCandidateUsed() {
    // TODO
  }

  get forceEdit(): boolean {
    return Boolean(this.$route?.query?.forceEdit) || false;
  }
  async submitV3(step?: number) {
    if (this.submitting) return;
    // 清除没用的数组new实例
    const processInfomation = this.examV3.processInformation.getCleanDefaultData();

    //todo 各个环节内提交前 可能需要校验的话 在这调起
    //...
    //第五步 数据校验
    if (this.currentStep === 4) {
      const step5DataOk = await (this.$refs["step5"] as any)?.checkData();
      if (!step5DataOk) {
        return;
      }
    }

    const param = JSON.parse(JSON.stringify(this.examV3));
    param.processInformation = processInfomation;
    if (this.isEdit) {
      //编辑时 todo 修改类型必传  updateType =  basicInformation|processInformation|settingInformation
      param.updateType =
        step === 4
          ? "settingInformation"
          : step === 1
          ? "processInformation"
          : "";
      if (step === 1) {
        const flag = (this.$refs.step4 as any).checkData();
        if (!flag) {
          return;
        }
      }
      if (step !== 4 && !this.userSureZero) {
        this.questionOrInspectScoreIsZeroList = (this.$refs
          .step4 as any).questionOrInspectScoreIsZeroList;
        if (this.questionOrInspectScoreIsZeroList.length > 0) {
          this.showZeroVisible = true;
          return;
        }
      }
    }

    this.submitting = true;
    ExamV3[this.isEdit ? "update" : "create"](param)
      .then(
        (res: any) => {
          if (res.code === 0) {
            this.submitting = false;
            //询问权限弹窗
            this.showAskPower(res.data.examId);
          } else {
            //
            this.submitting = false;
          }
        },
        () => {
          this.submitting = false;
          //报错后 返回
          (this.$refs.step5 as any)?.endLoading();
        }
      )
      .finally(() => {
        this.submitting = false;
      });
  }

  // 询问是否编辑权限
  showAskPower(examId: number) {
    this.ask = {
      title: `${this.isEdit ? "编辑" : "保存"}成功`,
      text: `面试已${
        this.isEdit ? "编辑" : "保存"
      }成功，系统生成题目视频、面试引导视频等需要一定时间，请等待5分钟后扫码参加面试`,
      okBtn: "设置管理权限",
      cancelBtn: "返回面试列表"
    };
    this.powerExamId = examId;
    this.askSubmit = true;

    // 新建后 清掉缓存
    if (!this.isEdit) {
      console.log("1232");
      this.clearCacheV3();
    }
  }

  // 面试权限弹窗
  toPower() {
    this.showPower = true;
  }

  // 上一步
  pre() {
    if (!this.canChangePage) return;
    this.beforePageChange();
    if (!this.isEdit) {
      this.isTemplateNextAfter = true;
    }
    if (this.currentStep === 0) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 1) {
      //todo 进行对应页面离开前的数据校验
      this.isFirstEnter = false;
    }
    if (this.currentStep === 2) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 3) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 4) {
      //todo 进行对应页面离开前的数据校验
      //限制时间 转化
      if (this.isEdit && this.exam.timeLimitExamType === 2) {
        this.exam.timeLimitExam = this.exam.timeLimitExam * 60;
      }
      // this.exam.timeLimitExam =
      // this.exam.timeLimitExam === 0 ? 86400 : this.exam.timeLimitExam * 60; //秒转分
    }

    this.showCurrentStep(this.currentStep - 1);

    if (this.isEdit) {
      this.getExam(false); // 获取是否有人答题
    }
  }

  // 下一步
  async next() {
    if (!this.canChangePage) return;
    this.beforePageChange();
    if (this.currentStep === 1) {
      this.isFirstEnter = false;
    }

    const ref: any = this.$refs[`step${this.currentStep + 1}`];
    const checkDataResult = ref?.checkData();
    if (!checkDataResult) return;
    // 导航条完成度状态变更
    if (!this.isEdit) {
      if (this.currentStep + 1 >= 2 && this.currentStep + 1 <= 4) {
        this.stepsList.forEach((el, index) => {
          if (index === this.currentStep - 1) {
            el.isComplete = true;
          }
        });
      }
    }

    // 编辑态，如果第5步中没有要身份证号，提示隐藏逻辑
    if (this.isEdit) {
      const hasBgCheck = this.examV3.processInformation.jobMatching.hasBgCheck;
      const hasIdCardNum = this.examV3.settingInformation.hasIdCardNum;

      console.log(hasBgCheck, !hasIdCardNum, !this.agreeAutoAddIdCard);

      if (hasBgCheck && !hasIdCardNum && !this.agreeAutoAddIdCard) {
        return (this.askAutoAddIdCard = true);
      }
    }

    if (this.currentStep === 3) {
      this.questionOrInspectScoreIsZeroList = (this.$refs
        .step4 as any).questionOrInspectScoreIsZeroList;
      if (this.questionOrInspectScoreIsZeroList.length > 0) {
        console.log(this.questionOrInspectScoreIsZeroList);
        this.showZeroVisible = true;
        return;
      }
    }

    this._next();

    // 实时判断是否有人答题
    if (this.isEdit) {
      await this.getExam(false);
      this.checkHasCandidateUsed();
    }
  }

  // 快速创建
  async quickCreate() {
    if (!this.canChangePage) return;
    if (this.temBackup.templateId) {
      this.examV3 = new ExamV3Custom().assign(this.temBackup);
    }
    this.beforePageChange();
    const ref: any = this.$refs[`step${this.currentStep + 1}`];
    const checkDataResult = ref?.checkData();
    if (!checkDataResult) return;
    this.showCurrentStep(4);
  }

  // 防止点太快
  beforePageChange() {
    this.canChangePage = false;
    this.canCancelPage = false;

    setTimeout(() => (this.canChangePage = true), this.pageInterval);
    setTimeout(() => (this.canCancelPage = true), this.cancelInterval);
  }

  // 不检查直接下一步
  _next() {
    this.showCurrentStep(this.currentStep + 1);
    if (!this.isEdit) {
      this.isTemplateNextAfter = true;
    }
  }

  back() {
    const value = localStorage.getItem("aibuildercachev3");
    if (this.isEdit || value) {
      this.cancel();
      return;
    }
    this.clearCacheV3();
    this.$router.push("/exam/list");
  }

  destroyed() {
    console.log("离开");
    this.vuexStores.updateAiStep({ show: false, step: 0 });
  }

  // 保存缓存
  saveCacheV3() {
    // 编辑面试不需要保存缓存
    if (this.isEdit) return;

    // 延迟缓存，以免自动分配分数时频繁IO
    if (this.saveDataTimer) clearTimeout(this.saveDataTimer);

    this.saveDataTimer = setTimeout(() => {
      this.saveDataTimer = null;
      localStorage.setItem("aibuildercachev3", JSON.stringify(this.examV3));
    }, 500);
  }

  loadCacheV3() {
    const cacheJson = localStorage.getItem("aibuildercachev3");
    if (cacheJson)
      this.examV3 = new ExamV3Custom().assign(JSON.parse(cacheJson));
  }

  clearCacheV3() {
    // 定时器存在可能导致缓存清除后再次缓存
    if (this.saveDataTimer) clearTimeout(this.saveDataTimer);
    localStorage.removeItem("aibuildercachev3");
  }

  goOn() {
    this.askGoOn = false;
    if (!this.isEdit) {
      this.$nextTick(() => {
        const step1 = this.$refs.step1 as any;
        if (step1 && step1.$refs && step1.$refs.basicModelCard) {
          step1.$refs.basicModelCard.isResumeExam = true;
        }
      });
    }
  }

  // 重新创建
  newCreate() {
    this.clearCacheV3();
    this.examV3 = new ExamV3Custom();

    this.$set(this.stepShow, 0, false);
    this.$nextTick(() => {
      this.$set(this.stepShow, 0, true);
    });
    this.askGoOn = false;
  }

  // 创建后提示弹窗
  submitOk() {
    this.$router.push("/exam/list");
  }

  // 取消后提示弹窗
  cancelOk() {
    if (!this.isEdit) {
      //新建 取消会清缓存
      this.clearCacheV3();
    } else {
      //编辑 本身就无缓存
    }
    this.$router.go(-2);
    // this.$router.push("/exam/list");
  }

  // 选中模板
  temBackup = new ExamV3Custom();

  selectTemp(t: ExamV3Custom) {
    if (t.templateId) {
      this.temBackup = t;
      this.stepsList.forEach((el, ind) => {
        el.isComplete = true;
      });
    } else {
      this.stepsList.forEach((el, ind) => {
        el.isComplete = false;
      });
    }
    this.examV3 = new ExamV3Custom().assign(t);
    this.isTemplateNextAfter = false;
    this.stepsListStatusChange();
    this.saveCacheV3();
  }

  // 打开预览及详情
  openDrawer() {
    this.visible = true;
  }

  visible = false;
  // 面试预览及详情
  handleClose() {
    this.visible = false;
  }
  builderV3StepsClick(index: number) {
    this.isFirstEnter = false;
    this.showCurrentStep(index + 1);
  }
  // 数据校验更新stepsList
  stepsListStatusChange() {
    const funDoMap = {
      0: "checkDataByTool",
      1: "checkDataByQuestion",
      2: "checkDataByScore"
    };
    for (let i = 0; i < this.stepsList.length; i++) {
      const flag = this.examV3.processInformation[funDoMap[i]](i == 0);
      if (i === 0 && !flag) {
        this.stepsList[0].isComplete = false;
        this.stepsList[1].isComplete = false;
        this.stepsList[2].isComplete = false;
        break;
      } else if (i === 0) {
        this.stepsList[0].isComplete = true;
      }
      if (i === 1 && !flag) {
        this.stepsList[1].isComplete = false;
        this.stepsList[2].isComplete = false;
        break;
      } else if (i === 1) {
        this.stepsList[1].isComplete = true;
      }
      if (i === 2 && !flag && !this.stepsList[1].isComplete) {
        this.stepsList[2].isComplete = false;
        break;
      } else if (i === 2) {
        this.stepsList[2].isComplete = true;
      }
    }
  }
}
